import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { DeviceListingFieldName, EquipmentListingFieldName } from '../../components/devices.models';

export const SENSORS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [DeviceListingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SENSORS.VIEW_TABLE.GNN_ID,
    value: 2,
    types: [DeviceListingFieldName.ServiceLocationIds],
    hintText: SEARCH_HINTS.GNN
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERIAL_NUMBER,
    value: 3,
    types: [DeviceListingFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  }
];

export const SENSORS_DEFAULT_SEARCH_TYPE: SearchType = SENSORS_SEARCH_TYPES[2];

export const SENSORS_SORT_FIELD: Record<string, EquipmentListingFieldName> = {
  deviceTypeName: DeviceListingFieldName.DeviceType,
  status: DeviceListingFieldName.Status,
  deviceStatusValue: DeviceListingFieldName.Health,
  lastHeard: DeviceListingFieldName.LastHeard,
  batteryStatus: DeviceListingFieldName.BatteryStatus,
  validTransmissionReadRateStatus: DeviceListingFieldName.ValidTransmissionReadRateStatus
};
